/**
 * Composant LoadingSpinner
 *
 * Spinner de chargement moderne avec animation
 * Utilise l'icône Loader2 de lucide-react
 *
 * @param {string} message - Message optionnel à afficher sous le spinner
 * @param {string} size - Taille du spinner (sm, md, lg)
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = ({ message = 'Chargement...', size = 'md' }) => {
  // Tailles du spinner
  const sizes = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
  };

  const iconSize = sizes[size] || sizes.md;

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] w-full">
      {/* Spinner animé */}
      <Loader2
        className={`${iconSize} text-blue-600 animate-spin`}
        strokeWidth={2}
      />

      {/* Message de chargement */}
      {message && (
        <p className="mt-4 text-sm text-gray-600 font-medium">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
